import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={49}
    height={49}
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_15370_1847)">
      <circle
        cx={24.5}
        cy={20.5}
        r={19.5}
        transform="rotate(-180 24.5 20.5)"
        fill="#1E1F22"
      />
      <circle
        cx={24.5}
        cy={20.5}
        r={19}
        transform="rotate(-180 24.5 20.5)"
        stroke="#485359"
      />
    </g>
    <g clipPath="url(#clip0_15370_1847)">
      <path
        d="M16.7212 20L26.5972 10.4651L29.2793 13.1119L22.3018 20L29.2793 26.8858L26.5949 29.5349L16.7212 20Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15370_1847"
        x={0.3}
        y={0.3}
        width={48.4}
        height={48.4}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2.35} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15370_1847"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15370_1847"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_15370_1847">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(33 30) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;
